import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-select-group',
  templateUrl: './icon-select-group.component.html',
  styleUrls: ['./icon-select-group.component.scss'],
})
export class IconSelectGroupComponent implements OnInit {
  @Input() type: string;
  @Input() icon: string;
  @Input() align: string;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() options: [];
  constructor() {}

  ngOnInit() {}
}
